import { Navigate } from "react-router-dom";
import { isAuthed, getClaims } from "../lib/api.js";
import { defaultRouteForRoles } from "../lib/roles.js";

/**
 * Entry gate for `/`. No UI — immediately routes by session:
 *  - signed out → /auth
 *  - signed in → /dashboard (role-adaptive hub)
 */
export function RootRedirect() {
  if (!isAuthed()) return <Navigate to="/auth" replace />;
  return <Navigate to={defaultRouteForRoles(getClaims()?.roles ?? [])} replace />;
}
